const Hero = () => {
  return (
    <section id="hero" className="relative bg-gradient-to-br from-primary-600 via-primary-700 to-primary-800 text-white overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
        <div className="text-center">
          <div className="inline-block mb-6 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full border border-white/30">
            <span className="text-sm sm:text-base font-semibold">
              🚀 Projet nextTunisia - Digitalisation horizon 2030
            </span>
          </div>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold mb-6 animate-fade-in">
            Tunisie Parking
          </h1>
          <p className="text-xl sm:text-2xl lg:text-3xl font-light mb-4 text-primary-100">
            La solution intelligente qui digitalise le stationnement en Tunisie
          </p>
          <p className="text-lg sm:text-xl text-primary-200 max-w-3xl mx-auto mb-8">
            Rejoignez la révolution de la mobilité urbaine. Une plateforme complète qui transforme 
            la gestion du parking pour les municipalités, les entreprises et les citoyens tunisiens.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="#probleme"
              className="px-8 py-4 bg-white text-primary-700 font-semibold rounded-lg shadow-lg hover:bg-primary-50 transition-all duration-300 transform hover:scale-105"
            >
              Découvrir la solution
            </a>
            <a
              href="#clients"
              className="px-8 py-4 bg-primary-500 text-white font-semibold rounded-lg shadow-lg hover:bg-primary-400 transition-all duration-300 transform hover:scale-105 border border-white/20"
            >
              Pour qui ?
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>
    </section>
  );
};

export default Hero;

